import { useContext } from 'react';

import { Context } from '../PageIdContextProvider';

function usePageIdContext() {
  return useContext(Context);
}

export { usePageIdContext };
